export const OBJ_SELECTIONDISPLAY = 'itemSelectionsDisplay'
export const OBJ_SELECTION = 'itemSelections'
export const OBJ_COLLECTION = 'itemCollections'
export const OBJ_AD = 'ads'
export const OBJ_WEISCHER = 'weischerAds'
export const OBJ_ADVERTISEMENT = "advertisements"
export const OBJ_HIGLLIGHT = 'highlights'
export const OBJ_PM_MOVIE = 'pmMovies'
export const OBJ_PY_EXTENSION = 'movieExtensions'
export const OBJ_META_MOVIE = 'metaMovies'
export const OBJ_ELBENWALD_BRAND_MAPPINGS = 'brandMovieMappingActions'
export const OBJ_PM_PREVIEW_MOVIE = 'pmPreviewMovies'